<template>
  <nav
    v-if="crumbs.length"
    :aria-label="t('aria-label.breadcrumbs')"
    role="navigation"
    class="relative flex shrink min-w-0 w-full overflow-x-auto scroll-shadow-right hide-scrollbar"
  >
    <ol class="text-sm font-medium leading-tight flex shrink min-w-0">
      <li
        v-for="(breadcrumb, index) in crumbs"
        :key="breadcrumb.href"
        class="flex relative whitespace-nowrap max-w-full"
        :class="{
          'shrink min-w-24': breadcrumb.label.length > 16,
        }"
      >
        <s-link
          class="flex items-center link-subtle outline-transparent focus-visible:outline-blue-400 -outline-offset-2 max-w-full pl-4 pr-3 py-1.5"
          :key="breadcrumb.href"
          :href="breadcrumb.href"
          :external="breadcrumb.external"
        >
          <span class="truncate"><s-latex :content="breadcrumb.label" :responsive="true" /></span>
        </s-link>
        <svg
          v-if="index < crumbs.length - 1"
          class="absolute top-0 right-0 h-full pointer-events-none translate-x-1/2"
          viewBox="0 0 13 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <g clip-path="url(#clip0_2_17)">
            <path
              d="M0 42L11.2164 21.4366C11.7048 20.5411 11.7048 19.4589 11.2164 18.5634L0 -2"
              stroke="#E5E5E5"
            />
          </g>
          <defs>
            <clipPath id="clip0_2_17">
              <rect width="13" height="40" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </li>
    </ol>
  </nav>
</template>
<script setup lang="ts">
import SLink from '../components/SLink.vue';
import SLatex from '../components/SLatex.vue';
import {useI18n} from 'vue-i18n';
import {usePage} from '@inertiajs/vue3';
import {computed} from 'vue';

type Breadcrumb = {
  label: string;
  href: string;
  external?: boolean;
};

const {t} = useI18n({
  inheritLocale: true,
  useScope: 'local',
});

const props = defineProps<{breadcrumbs: Breadcrumb[]}>();

const page = usePage();

const crumbs = computed<Breadcrumb[]>(() => {
  return (page.props.breadcrumbs as Breadcrumb[]) || props.breadcrumbs || [];
});
</script>
<i18n>
{
  "en": {
    "aria-label": {
      "breadcrumbs": "Breadcrumbs"
    }
  },
  "fr": {
    "aria-label": {
      "breadcrumbs": "Fil d'Ariane"
    }
  }
}
</i18n>
